import React, { useState, useEffect } from "react";
import { colors } from "../../../themes/Colors";
import BaseButtons from "../base-buttons/BaseButtons";
import { NewSectionButton } from "./components";
import TextInputField from "../text-input-field/TextInputField";
import DropDownWithButton from "../drop-down-with-button/DropDownWithButton";
import CheckInput from "../check-input/CheckInput";
import TextInputFieldArea from "../text-input-field/TextInputFieldArea";
import ImageUploadAWS from "../../user/components/image-upload/ImageUploadAWS";
import { useNavigate } from "react-router-dom";
import AWS from "aws-sdk";

const validFileTypes = ["image/jpg", "image/jpeg", "image/png"];

const ProfilePopUpDisplay = ({
  profileDisplay,
  setProfileDisplay,
  user,
  shareAccount,
  setConfirmShareAccount,
  confirmShareAccount,
  CreateShareAccount,
  businessData,
  setLoading,
  setRefresh,
  refresh,
  setModulePopUp,
  modulePopUp,
  AdminNavigate,
  adminRole,
  agencyRole,
  privateInformation,
  setMessage,
  setToastPop,
  setPopUpTitle,
}) => {
  const navigate = useNavigate();

  const [shareAccountDataDropDown, setShareAccountDataDropDown] =
    useState(false);

  const [basicInfoDropDown, setBasicInfoDropDown] = useState(false);

  const [oraginsationCreateDropDown, setOrginisationCreateDropDown] =
    useState(false);
  const [oraginsationCreate, setOrginisationCreate] = useState(false);
  const [createdOrganisation, setCreatedOrganisation] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [cellNumber, setCellNumber] = useState("");
  const [email, setEmail] = useState("");

  const [rolesArray, setRolesArray] = useState(null);

  const [selectedService, setSelectedService] = useState(
    "Click here to select service"
  );

  // this will be the business variables
  const [businessName, setBusinessName] = useState("");
  const [callouts, setCallouts] = useState(false);
  const [businessCell, setBusinessCell] = useState("");
  const [businessLandline, setBusinessLandline] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [businessWebsite, setBusinessWebsite] = useState("");
  const [about, setAbout] = useState("");

  // this will be organisation varoables

  const [orginisationExists, setOrginisationExists] = useState(null);
  const [createOrg, setCreateOrg] = useState(false);

  const [orgName, setOrgName] = useState("");
  const [orgId, setOrgId] = useState("");
  const [orgEmail, setOrgEmail] = useState("");

  // this will be the orivate info variables
  const [privateInfoPopUp, setPrivateInfoPopUp] = useState(false);
  const [privateInfoActive, setPrivateInfoActive] = useState(null);

  const [address, setAddress] = useState("");
  const [preferredName, setPreferredName] = useState("");
  const [idNumber, setIdnumber] = useState("");
  const [driverLiscenseExpiryDate, setDriverLiscenseExpiryDate] = useState("");
  const [driverLiscense, setDriverLiscense] = useState("");

  const [driverLiscenseImageDisplay, setDriversLiscenseImageDIsplay] =
    useState(null);
  // const [driverLiscenseImage, setDriverLiscenseImage] = useState("");
  const [imageError, setImageError] = useState("");

  const handleFileChangeDriverLiscense = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setDriverLiscense(file);
  };
  const getUplaodImage = async () => {
    const S3_BUCKET = process.env.REACT_APP_BUCKET;
    const apiKey = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
    const secrectapiKey = process.env.REACT_APP_AWS_SECRET_KEY_ID;
    AWS.config.update({
      accessKeyId: apiKey,
      secretAccessKey: secrectapiKey,
    });
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: process.env.REACT_APP_REGION,
      signatureVersion: "v4",
    });

    const params = {
      Bucket: S3_BUCKET,
      Key: privateInformation ? privateInformation.driverLicenseImageId : null,
    };

    var promise = s3.getSignedUrlPromise("getObject", params);
    // return promise;
    promise.then(
      function (url) {
        if (url) {
          setDriversLiscenseImageDIsplay(url);
        }
        return url;
      },
      function (err) {
        console.log(err);
      }
    );
  };
  const RequestBusinessCreation = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/thirdParty/createBusinessRequest",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: user.userId,
            businessName: businessName,
            service: selectedService,
            callouts: callouts ? "YES" : "NO",
            cellNumber: businessCell,
            email: businessEmail,
            landline: businessLandline || "N/A",
            website: businessWebsite,
            aboutUs: about,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setCreatedOrganisation(true);
        setLoading(false);
        setRefresh(refresh ? false : true);
        // setToastPop(true);
      } else {
        setLoading(false);
      }
    } catch (err) {}
  };

  const CreatePrivateInformation = async (e) => {
    setLoading(true);
    let file = driverLiscense;

    if (!validFileTypes.find((type) => type === file.type)) {
      setImageError("File type must be JPG or PNG format");
      return;
    } else {
      setImageError("");
    }
    try {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("userId", user.userId);
      formData.append("preferredName", preferredName);
      formData.append("address", address);
      formData.append("idNumber", idNumber);
      formData.append("driverLicenseExpiry", driverLiscenseExpiryDate);

      //   userId,
      // preferredName,
      // address,
      // idNumber,
      // driverLicenseExpiry,

      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/privateInformation/createPrivateInformation",
        {
          method: "POST",
          body: formData,
        }
      );
      const respnseData = await response.json();
      console.log("response", respnseData);
      if (respnseData.success) {
        setPrivateInfoPopUp(false);
        setToastPop(true);
        setMessage(respnseData.success);
        setPopUpTitle("SUCCESS");
        setLoading(false);
        setRefresh(refresh ? false : true);
        // setVehicleSearchArray(respnseData.enatisVehicles);
      } else {
        setToastPop(true);
        setMessage(respnseData.error);
        setPopUpTitle("FAILURE");
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  useEffect(() => {
    if (profileDisplay) {
      setFirstName(user.firstName);
      setLastName(user.lastName);
      setCellNumber(user.cellNumber);
      setEmail(user.email);
      // setRolesArray(shareAccount.linkedRoles);
    }
    if (shareAccount) {
      setRolesArray(shareAccount.linkedRoles);
    }
    if (businessData) {
      if (businessData.status === "PENDING") {
        setCreatedOrganisation(true);
      } else {
        setCreatedOrganisation(false);
      }
      setBusinessName(businessData.businessName);
      setSelectedService(businessData.service);
      setCallouts(businessData.callOut);
      setBusinessCell(businessData.cellNumber);
      setBusinessLandline(businessData.landline);
      setBusinessEmail(businessData.email);
      setBusinessWebsite(businessData.website);
      setAbout(businessData.aboutUs);
    }
    if (privateInformation) {
      setPreferredName(privateInformation.preferredName);
      setAddress(privateInformation.address);
      setIdnumber(privateInformation.idNumber);
      setDriverLiscenseExpiryDate(privateInformation.driverLicenseExpiry);
      getUplaodImage();
    }
  }, [profileDisplay, shareAccount, businessData, user]);
  return (
    <div
      style={{
        zIndex: 10,
        position: "absolute",
        right: 0,
        height: "100%",
        maxHeight: 800,
        minHeight: 800,
        width: profileDisplay ? 350 : 0,
        backgroundColor: colors.white,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        transition: "all 0.3s",
        WebkitBoxShadow: profileDisplay
          ? "-5px 5px 15px -1px #00000050"
          : "0px 0px 0px 0px #00000070",
        marginTop: 50,
      }}
    >
      {/* <div style={{ minHeight: 60 }} /> */}
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          marginTop: -30,
        }}
      >
        <BaseButtons
          width={"94%"}
          label={"CHANGE MODULE"}
          backgroundColor={colors.greenLight}
          height={40}
          borderRadius={4}
          onClick={() => setModulePopUp(true)}
        />
        <div
          style={{
            width: "100%",
            backgroundColor: colors.white,
            borderRadius: 8,
            display: "flex",
            flexDirection: "column",
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
            top: 0,
            height: modulePopUp ? 240 : 0,
            overflowY: "hidden",
            zIndex: 100,
            transition: "height 0.3s",
          }}
        >
          <BaseButtons
            width={"90%"}
            label={"GO TO ADMIN"}
            backgroundColor={colors.greenDark}
            height={50}
            borderRadius={8}
            disabled={adminRole ? false : true}
            onClick={() => AdminNavigate()}
          />
          <div style={{ height: 20 }} />
          <BaseButtons
            width={"90%"}
            label={"GO TO AGENCY"}
            backgroundColor={colors.greenDark}
            height={50}
            borderRadius={8}
            disabled={agencyRole ? false : true}
          />
          <div style={{ height: 20 }} />
          <BaseButtons
            width={"90%"}
            label={"CANCEL"}
            backgroundColor={colors.orangeDark}
            height={50}
            borderRadius={8}
            onClick={() => setModulePopUp(false)}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-evenly",
          marginTop: 10,
        }}
      >
        <div style={{ zIndex: 1, width: "45%" }}>
          <BaseButtons
            label={"CLOSE"}
            borderRadius={4}
            backgroundColor={colors.greenLight}
            width={"100%"}
            onClick={() => setProfileDisplay(false)}
            height={40}
          />
        </div>

        <BaseButtons
          label={"LOG OUT"}
          borderRadius={4}
          backgroundColor={colors.orangeDark}
          width={"45%"}
          onClick={() => setProfileDisplay(false)}
          height={40}
        />
      </div>

      <div
        style={{
          // borderStyle: "solid",
          height: "83%",
          width: "100%",
          overflowY: "scroll",
          overflowX: "hidden",
          scrollbarWidth: "none",
        }}
      >
        <div style={{ height: 10 }} />
        <NewSectionButton
          backgroundColor={colors.greenDark}
          title={"BASIC INFORMATION"}
          fontColor={colors.white}
          notBasic={true}
          // onClick={() => setConfirmShareAccount(true)}
          // open={shareAccountData ? true : false}
          onActiveClick={() =>
            setBasicInfoDropDown(basicInfoDropDown ? false : true)
          }
          active={true}
          dropDownMarker={basicInfoDropDown}
        />
        {/* basic data */}
        <div
          style={{
            width: "100%",
            height: basicInfoDropDown ? 450 : 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            transition: "all 0.3s",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            <div style={{ width: "80%", textAlign: "center" }}>
              This is your basic account information scroll down to add new
              features and sign up to other services
            </div>
          </div>
          <TextInputField
            labelTitle={"First Name"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={firstName}
            readOnly={true}
          />
          <TextInputField
            labelTitle={"Last Name"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={lastName}
            readOnly={true}
          />
          <TextInputField
            labelTitle={"Cell Number"}
            mini={true}
            width={"100%"}
            size={"80%"}
            readOnly={true}
            value={cellNumber}
          />
          <TextInputField
            labelTitle={"Email"}
            mini={true}
            width={"100%"}
            size={"80%"}
            readOnly={true}
            value={email}
          />
        </div>
        <div style={{ padding: 10 }}></div>
        <NewSectionButton
          notBasic={privateInformation ? true : false}
          backgroundColor={colors.greenDark}
          title={"PRIVATE INFORMATION"}
          fontColor={colors.white}
          onClick={() => setPrivateInfoPopUp(true)}
          // open={shareAccountData ? true : false}
          active={privateInformation ? true : false}
          onActiveClick={() =>
            setPrivateInfoPopUp(privateInfoPopUp ? false : true)
          }
        />
        <div
          style={{
            width: "100%",
            height: privateInfoPopUp ? (privateInformation ? 700 : 710) : 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            transition: "all 0.3s",
          }}
        >
          {privateInformation ? null : (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: 20,
                marginBottom: 20,
              }}
            >
              <div style={{ width: "80%", textAlign: "center" }}>
                This is your Private account information scroll down to fill out
                the information required.. this will gove you access t the main
                features of driver friend
              </div>
            </div>
          )}
          {privateInformation ? <div style={{ height: 40 }} /> : null}
          <TextInputField
            labelTitle={"PREFERRED NAME"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={preferredName}
            readOnly={privateInformation ? true : false}
            onChange={(e) => setPreferredName(e.target.value)}
          />

          <TextInputFieldArea
            labelTitle={"ADDRESS"}
            mini={true}
            width={"100%"}
            size={"80%"}
            readOnly={privateInformation ? true : false}
            value={address}
            height={100}
            onChange={(e) => setAddress(e.target.value)}
          />
          <TextInputField
            labelTitle={"ID NUMBER"}
            mini={true}
            width={"100%"}
            size={"80%"}
            readOnly={privateInformation ? true : false}
            value={idNumber}
            onChange={(e) => setIdnumber(e.target.value)}
          />
          {privateInformation ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginBottom: 20,
              }}
            >
              <div style={{ width: "80%", marginBottom: 10, marginTop: 20 }}>
                DRIVERS LICENSE
              </div>
              <div
                style={{
                  width: "80%",
                  height: 180,
                  borderStyle: "solid",
                  borderRadius: 8,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  alt="icon"
                  src={driverLiscenseImageDisplay}
                  style={{ height: "100%", minHeight: 150, maxHeight: 250 }}
                />
              </div>
            </div>
          ) : (
            <ImageUploadAWS
              onChange={(e) => handleFileChangeDriverLiscense(e)}
              labelTitle={"UPLOAD DRIVERS LISCENSE IMAGE"}
              mini={true}
              errorDisplay={imageError}
              width={"100%"}
              size={"80%"}
            />
          )}
          <TextInputField
            labelTitle={"DRIVERS LICENSE EXPIRY DATE"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={driverLiscenseExpiryDate}
            readOnly={privateInformation ? true : false}
            onChange={(e) => setDriverLiscenseExpiryDate(e.target.value)}
          />
          {privateInformation ? null : (
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-evenly",
                alignItems: "center",
                marginTop: 25,
              }}
            >
              <BaseButtons
                label={"CANCEL"}
                borderRadius={8}
                backgroundColor={colors.orangeDark}
                width={"40%"}
                onClick={() => setPrivateInfoPopUp(false)}
              />
              <BaseButtons
                label={"SUBMIT"}
                borderRadius={8}
                backgroundColor={colors.greenLight}
                width={"40%"}
                disabled={
                  preferredName.length >= 2 &&
                  address.length >= 10 &&
                  idNumber.length >= 6 &&
                  driverLiscense &&
                  driverLiscenseExpiryDate.length >= 6
                    ? false
                    : true
                }
                onClick={() => CreatePrivateInformation()}
              />
            </div>
          )}
        </div>
        <div style={{ padding: 10 }}></div>

        <NewSectionButton
          backgroundColor={colors.greenDark}
          title={"SHARE ACCOUNT"}
          fontColor={colors.white}
          onClick={() => setConfirmShareAccount(true)}
          // open={shareAccountData ? true : false}
          onActiveClick={() =>
            setShareAccountDataDropDown(shareAccountDataDropDown ? false : true)
          }
          active={shareAccount ? true : false}
        />
        {confirmShareAccount ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{ marginTop: 20, marginBottom: 10, fontWeight: "bold" }}
            >
              ARE YOU SURE?
            </div>
            <div>YOU WANT TO CREATE A SHARE ACCOUNT?</div>
            <div style={{ display: "flex", marginTop: 20 }}>
              <BaseButtons
                label={"YES"}
                onClick={() => CreateShareAccount()}
                backgroundColor={colors.greenDark}
                borderRadius={4}
                width={80}
              />
              <div style={{ width: 20 }} />
              <BaseButtons
                label={"NO"}
                onClick={() => setConfirmShareAccount(false)}
                backgroundColor={colors.orangeDark}
                borderRadius={4}
                width={80}
              />
            </div>
          </div>
        ) : null}
        <div
          style={{
            height: shareAccount && shareAccountDataDropDown ? 300 : 0,
            width: "100%",
            transition: "all 0.2s",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <div style={{ flex: 1 }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: 20,
                marginBottom: 20,
              }}
            >
              <div style={{ width: "80%", textAlign: "center" }}>
                You have created a share PIN, you can give your username (email)
                and pin to auser and they can invite you into the to different
                modules
              </div>
            </div>
            <TextInputField
              labelTitle={"USERNAME"}
              mini={true}
              width={"100%"}
              size={"80%"}
              readOnly={true}
              value={user.email}
            />
            <TextInputField
              labelTitle={"PIN"}
              mini={true}
              width={"100%"}
              size={"80%"}
              readOnly={true}
              value={shareAccount ? shareAccount.pin : "loading"}
            />
          </div>

          {/* <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              alignItems: "center",
              overflow: "hidden",
              paddingBottom: shareAccountData ? 20 : 0,
            }}
          >
            <BaseButtons
              label={"CANCEL"}
              backgroundColor={colors.orangeDark}
              borderRadius={8}
              width={140}
              onClick={() => setShareAccountData(null)}
            />
            <BaseButtons
              label={"SUBMIT"}
              backgroundColor={colors.greenDark}
              borderRadius={8}
              width={140}
            />
          </div> */}
        </div>
        {shareAccount && shareAccountDataDropDown ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "80%",
                fontSize: 18,
                fontWeight: "bold",
                marginBottom: 10,
              }}
            >
              Roles:
            </div>
            {rolesArray
              ? rolesArray.map((role, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        backgroundColor: colors.greenLight,
                        padding: 10,
                        borderRadius: 8,
                        width: "80%",
                        marginTop: 5,
                        color: colors.white,
                      }}
                    >
                      {role}
                    </div>
                  );
                })
              : null}

            <div
              style={{
                width: "80%",
                fontSize: 18,
                fontWeight: "bold",
                marginBottom: 10,
                marginTop: 20,
              }}
            >
              Linked Users:
            </div>
            <div
              style={{
                backgroundColor: colors.white,
                padding: 10,
                borderRadius: 8,
                width: "80%",
              }}
            >
              No users
            </div>
            <div
              style={{
                width: "80%",
                fontSize: 18,
                fontWeight: "bold",
                marginBottom: 10,
                marginTop: 20,
              }}
            >
              Linked Agents:
            </div>
            <div
              style={{
                backgroundColor: colors.white,
                padding: 10,
                borderRadius: 8,
                width: "80%",
              }}
            >
              No agents
            </div>
          </div>
        ) : null}
        <div style={{ padding: 10 }}></div>
        <NewSectionButton
          backgroundColor={colors.greenDark}
          title={"CREATE BUSINESS"}
          fontColor={colors.white}
          onClick={() => setOrginisationCreate(true)}
          // open={shareAccountData ? true : false}
          onActiveClick={() =>
            setOrginisationCreateDropDown(
              oraginsationCreateDropDown ? false : true
            )
          }
          active={businessData}
        />
        <div
          style={{
            height:
              oraginsationCreate || oraginsationCreateDropDown
                ? createdOrganisation
                  ? 200
                  : 770
                : 0,
            width: "100%",
            transition: "all 0.2s",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {createdOrganisation ? (
            <div
              style={{
                width: "100%",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: 40,
              }}
            >
              <div style={{ width: "80%", textAlign: "center" }}>
                Your business request has been sent for approval and will become
                active as soon as yo are APPROVED...
              </div>
            </div>
          ) : (
            <div style={{ flex: 1 }}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 20,
                  marginBottom: 20,
                  flexDirection: "column",
                }}
              >
                {businessData ? null : (
                  <div style={{ width: "80%", textAlign: "center" }}>
                    You are about to create a orginisation which will add some
                    new features you will have access too... first you will have
                    the possiblity to become a value added service as well as
                    much more..
                  </div>
                )}
                <TextInputField
                  width={"80%"}
                  size={"90%"}
                  labelTitle={"Business name"}
                  mini={true}
                  value={businessName}
                  onChange={(e) => setBusinessName(e.target.value)}
                />

                <DropDownWithButton
                  title={selectedService}
                  width={290}
                  data={[
                    "TYRE'S",
                    "WINDOWS",
                    "SALES",
                    "MAINTENANCE",
                    "EXHAUST",
                    "CARWASH",
                  ]}
                  setSelectedItem={setSelectedService}
                  set={
                    selectedService !== "Click here to select service" &&
                    businessData
                      ? true
                      : false
                  }
                />

                <div style={{ width: "80%", marginTop: 40, marginBottom: 20 }}>
                  <CheckInput
                    label={"CALL OUTS"}
                    selected={callouts}
                    onClick={() => setCallouts(callouts ? false : true)}
                  />
                </div>
                <TextInputField
                  width={"80%"}
                  size={"90%"}
                  labelTitle={"Cell number"}
                  mini={true}
                  value={businessCell}
                  onChange={(e) => setBusinessCell(e.target.value)}
                />
                <TextInputField
                  width={"80%"}
                  size={"90%"}
                  labelTitle={"Landline"}
                  mini={true}
                  value={businessLandline}
                  onChange={(e) => setBusinessLandline(e.target.value)}
                />
                <TextInputField
                  width={"80%"}
                  size={"90%"}
                  labelTitle={"Email"}
                  mini={true}
                  value={businessEmail}
                  onChange={(e) => setBusinessEmail(e.target.value)}
                />
                <TextInputField
                  width={"80%"}
                  size={"90%"}
                  labelTitle={"Website"}
                  mini={true}
                  value={businessWebsite}
                  onChange={(e) => setBusinessWebsite(e.target.value)}
                />
                <TextInputFieldArea
                  width={"80%"}
                  size={"90%"}
                  labelTitle={"About your company"}
                  mini={true}
                  height={100}
                  value={about}
                  onChange={(e) => setAbout(e.target.value)}
                />
                {businessData ? null : (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                      marginTop: 25,
                    }}
                  >
                    <BaseButtons
                      label={"CANCEL"}
                      borderRadius={8}
                      backgroundColor={colors.orangeDark}
                      width={"40%"}
                      onClick={() => setOrginisationCreate(false)}
                    />
                    <BaseButtons
                      label={"SUBMIT"}
                      borderRadius={8}
                      backgroundColor={colors.greenLight}
                      width={"40%"}
                      disabled={
                        businessData === "No Business created"
                          ? true
                          : businessName.length > 1 &&
                            selectedService !==
                              "Click here to select service" &&
                            businessCell.length > 6 &&
                            businessEmail.length > 6 &&
                            businessWebsite.length > 6 &&
                            about.length > 10
                          ? false
                          : true
                      }
                      onClick={() => RequestBusinessCreation()}
                      // onClick={() => {
                      //   setCreatedOrganisation(true);
                      //   setOrginisationCreate(false);
                      // }}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div style={{ padding: 10 }}></div>
        <NewSectionButton
          backgroundColor={colors.greenDark}
          title={orginisationExists ? "ORG NAME" : "CREATE ORGANISATION"}
          fontColor={colors.white}
          onClick={() => setCreateOrg(true)}
          // open={shareAccountData ? true : false}
          onActiveClick={() => setCreateOrg(createOrg ? false : true)}
          active={orginisationExists}
        />
        <div
          style={{
            height: createOrg ? (orginisationExists ? 510 : 660) : 0,
            width: "100%",
            transition: "all 0.2s",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <div style={{ flex: 1 }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: 20,
                marginBottom: 20,
                flexDirection: "column",
              }}
            >
              {orginisationExists ? null : (
                <div style={{ width: "80%", textAlign: "center" }}>
                  You are about to create a orginisation which will add some new
                  features you will have access too... first you will have the
                  possiblity to manage your Branches and assign managers ...
                </div>
              )}
              <ImageUploadAWS
                onChange={(e) => handleFileChangeDriverLiscense(e)}
                labelTitle={"UPLOAD COMPANY LOGO"}
                mini={true}
                errorDisplay={imageError}
                width={"100%"}
                size={"80%"}
              />
              <TextInputField
                width={"80%"}
                size={"90%"}
                labelTitle={"Organisation name"}
                mini={true}
                value={orgName}
                onChange={(e) => setOrgName(e.target.value)}
              />

              <TextInputField
                width={"80%"}
                size={"90%"}
                labelTitle={"Organisation Id"}
                mini={true}
                value={orgId}
                onChange={(e) => setOrgId(e.target.value)}
              />

              <TextInputField
                width={"80%"}
                size={"90%"}
                labelTitle={"Organisation email"}
                mini={true}
                value={orgEmail}
                onChange={(e) => setOrgEmail(e.target.value)}
              />
              <TextInputField
                width={"80%"}
                size={"90%"}
                labelTitle={"CIPRO Registration"}
                mini={true}
                value={orgEmail}
                onChange={(e) => setOrgEmail(e.target.value)}
              />
              <TextInputField
                width={"80%"}
                size={"90%"}
                labelTitle={"Address"}
                mini={true}
                value={orgEmail}
                onChange={(e) => setOrgEmail(e.target.value)}
              />

              {orginisationExists ? (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    marginTop: 25,
                    flexDirection: "column",
                    // height: 130,
                  }}
                >
                  {/* <BaseButtons
                    label={"GO TO ORGANISATION MANAGER"}
                    borderRadius={8}
                    backgroundColor={colors.orangeDark}
                    width={"90%"}
                    onClick={() => setCreateOrg(false)}
                  /> */}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    marginTop: 25,
                  }}
                >
                  <BaseButtons
                    label={"CANCEL"}
                    borderRadius={8}
                    backgroundColor={colors.orangeDark}
                    width={"40%"}
                    onClick={() => setCreateOrg(false)}
                  />
                  <BaseButtons
                    label={"SUBMIT"}
                    borderRadius={8}
                    backgroundColor={colors.greenLight}
                    width={"40%"}
                    onClick={() => setOrginisationExists(true)}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <BaseButtons
            label={"GO TO ORGANISATION"}
            borderRadius={8}
            backgroundColor={colors.greenLight}
            width={"90%"}
            onClick={() => navigate("/organisation")}
          />
        </div>
      </div>
    </div>
  );
};

export default ProfilePopUpDisplay;
